import { up } from 'slide-element';
import { getElementParents } from '../helpers/general';

if (document.cookie.indexOf('cookiesAccepted=') < 0) {
  document.querySelector('#cookie-notification')?.classList.remove('no-display');
}

document.querySelectorAll('#cookie-notification .close-alert').forEach((closeAlert) => {
  closeAlert.addEventListener('click', (e) => {
    e.preventDefault();

    const expiry = new Date();

    expiry.setFullYear(expiry.getFullYear() + 1);

    document.cookie = 'cookiesAccepted=yes; expires=' + expiry.toGMTString() + '; path=/';

    getElementParents(e.currentTarget, '.alert').forEach((parent) => {
      up(parent);
    });
  });
});
